module.exports = __webpack_public_path__ + "static/media/12.e5bf88c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/12.jpg
// module id = 173
// module chunks = 0